var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.034,
    height: 28.987,
    viewBox: "0 0 25.034 28.987",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1925",
    "data-name": "Group 1925",
    transform: "translate(-1 -18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_104471_android_icon",
    "data-name": "104471_android_icon",
    transform: "translate(1 18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15969",
    "data-name": "Path 15969",
    d: "M26.754,6.8l.324-.474L27.4,5.86l.715-1.049a.278.278,0,0,0-.079-.389.291.291,0,0,0-.4.078l-.766,1.125-.322.473-.327.479a9.8,9.8,0,0,0-6.824,0L19.068,6.1l-.322-.473L17.978,4.5a.291.291,0,0,0-.4-.078.277.277,0,0,0-.079.389l.715,1.049.319.468.324.474a6.383,6.383,0,0,0-4.081,5.614H30.835A6.383,6.383,0,0,0,26.754,6.8Zm-7.389,3.37a.841.841,0,1,1,.86-.841A.851.851,0,0,1,19.365,10.171Zm6.881,0a.841.841,0,1,1,.861-.841A.851.851,0,0,1,26.247,10.171Z",
    transform: "translate(-10.288 -4.374)",
    fill: "#2fda7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15970",
    "data-name": "Path 15970",
    d: "M14.9,20.208h-.124V32.551a1.8,1.8,0,0,0,1.816,1.777H17.9a1.647,1.647,0,0,0-.069.467v3.554a1.721,1.721,0,0,0,3.442,0V34.794a1.693,1.693,0,0,0-.068-.467H24.4a1.646,1.646,0,0,0-.068.467v3.554a1.721,1.721,0,0,0,3.441,0V34.794a1.65,1.65,0,0,0-.068-.467h1.31a1.8,1.8,0,0,0,1.816-1.777V20.208H14.9Z",
    transform: "translate(-10.288 -11.044)",
    fill: "#2fda7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15971",
    "data-name": "Path 15971",
    d: "M8.7,20.208a1.683,1.683,0,0,0-1.683,1.684v7.2a1.683,1.683,0,0,0,3.366,0v-7.2A1.683,1.683,0,0,0,8.7,20.208Z",
    transform: "translate(-7.021 -11.044)",
    fill: "#2fda7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15972",
    "data-name": "Path 15972",
    d: "M45.542,20.208a1.682,1.682,0,0,0-1.683,1.684v7.2a1.682,1.682,0,1,0,3.365,0v-7.2A1.682,1.682,0,0,0,45.542,20.208Z",
    transform: "translate(-22.189 -11.044)",
    fill: "#2fda7b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.20e01bc14e59883120d14c70690b2009.svg";
export { ForwardRef as ReactComponent };